import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import moment from 'moment';
import { SaveMission } from '../../../store/actions/mission.actions';
import { CustomerFilesInterface } from '../../../models/customer-files.interface';
import { FileService } from '../../../services/file.service';
import { environment } from '../../../../../../environments/environment';
import * as FileSaver from 'file-saver';
import { LineInterface } from '../../../../lines/models/line.interface';
import { ConstsHelper } from '../../../../../helpers/consts.helper';

@Component({
  selector: 'app-consumptions-details',
  templateUrl: './consumptions-details.component.html',
  styleUrls: ['./consumptions-details.component.css'],
  standalone: false
})
export class ConsumptionsDetailsComponent implements OnInit {

  @Input()
  line: LineInterface;

  selectedStartDate: Date|null;
  selectedFinishDate: Date|null;
  maxDate: Date|null;
  files: Array<CustomerFilesInterface>;
  alternatedBackground: boolean;

  constructor(
    private store: Store<any>,
    private fileService: FileService,
  ) { }

  ngOnInit() {
    this.selectedStartDate = null;
    this.selectedFinishDate = null;
    this.alternatedBackground = true;
    this.maxDate = new Date();
    this.files = [];
    this.fileService.files(
        {
          bucket_slug: environment.data.customerFilesBucketSlug,
          type_slugs: [ConstsHelper.PROCEDURE_CONSUMPTIONS_DETAILS],
          extra: this.line.phoneNumber
        }
    ).subscribe(
        res => {
          this.files = res;
        }
    );
  }

  setSelectedDate(event, type: string) {
    if (type === 'start') {
      this.selectedStartDate = event;
      this.selectedFinishDate = null;
      if (moment(this.selectedStartDate).add(31, 'days').isBefore(this.maxDate)) {
          this.maxDate = moment(this.selectedStartDate).add(31, 'days').toDate();
      }
    } else {
      this.selectedFinishDate = event;
    }
  }

  confirmation() {
    if (
      moment(this.selectedFinishDate).diff(this.selectedStartDate, 'days') > 0 &&
      moment().isSameOrAfter(this.selectedFinishDate)
    ) {
      this.store.dispatch(
        new SaveMission(
          {
            phoneNumber: this.line.phoneNumber,
            since: moment(this.selectedStartDate).format('YYYY-MM-DD'),
            until: moment(this.selectedFinishDate).format('YYYY-MM-DD'),
          },
          ConstsHelper.PROCEDURE_CONSUMPTIONS_DETAILS
        )
      );
    }
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  downloadFile(id: number, filename: string) {
    this.fileService.downloadFileById(id).subscribe(
        response => {
          FileSaver.saveAs(
              new Blob(
                  [response],
                  {type: 'application/octet-stream'}
              ),
              filename + '.xlsx'
          );
        }
    );
  }

  setBackgroundColor(index: number) {
    if (index % 2 === 0) {
      this.alternatedBackground = true;
    } else {
      this.alternatedBackground = false;
    }
    return this.alternatedBackground;
  }
}
